__turbopack_context__.v({
  "canvasContainer": "FourOhFour-module__LxZw7G__canvasContainer",
  "messageContainer": "FourOhFour-module__LxZw7G__messageContainer",
  "messageHeader": "FourOhFour-module__LxZw7G__messageHeader",
});
